import { SearchParameters } from "../interfaces/SearchParameters.interface";

export const getSingleChoiceQueryParameters = (
  searchParams: SearchParameters
): Map<string, string> => {
  const params = new Map<string, string>();
  params.set("dato", searchParams.date);
  params.set("spraak", searchParams.spraak);
  params.set("publisering", searchParams.publisering + "");
  params.set("V4", searchParams.V4 + "");
  return params;
};

export const getMultipleChoiceQueryParameters = (
  searchParams: SearchParameters
): Map<string, string> => {
  const params = new Map<string, string>();
  if (searchParams.areaType === "fylker") {
    if (searchParams.fylkesNummer.length > 0) {
      params.set("fylke", searchParams.fylkesNummer.join(","));
    }
  } else {
    if (searchParams.kommuneNummer.length > 0) {
      params.set("kommune", searchParams.kommuneNummer.join(","));
    }
  }
  const trimmed = trimCommaseparatedString(searchParams.vegsystemReferanse);
  if (trimmed.length > 0) {
    params.set("vegsystemreferanse", trimmed);
  }
  return params;
};

function trimCommaseparatedString(commaSepatatedString: string) {
  var refArr: string[] = [];
  commaSepatatedString.split(",").forEach(vegsysRef => {
    let trimmedRef = vegsysRef.trim();
    if (trimmedRef.length > 0) {
      refArr.push(trimmedRef);
    }
  });
  return refArr.join(",");
}
